import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./auth/auth.slice";
import dashbaordReducer from "./dashboard/dashboard.slice";
import userReducer from "./user/user.slice";
import postReducer from "./post/post.slice";
import reelReducer from "./reel/reel.slice";
import opencallReducer from "./opencall/opencall.slice";
import notificationReducer from "./notification/notification.slice";
import liveUserReducer from "./live/live.slice";
import roleFeaturesReducer from "./role-features/roleFeatures.slice";
import starFeedReducer from "./star-feed/star-feed.slice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashbaordReducer,
  user: userReducer,
  post: postReducer,
  reel: reelReducer,
  opencall: opencallReducer,
  notification: notificationReducer,
  live: liveUserReducer,
  roleFeatures: roleFeaturesReducer,
  starFeed: starFeedReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user", "post", "reel", "opencall", "starFeed"],
  version: 2,
  migrate: async (state: any) => {
    if (state && state.opencall) {
      const { opencall, ...rest } = state;
      return rest;
    }
    return state;
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
